import { queryOptions, useQuery } from '@tanstack/react-query';
import { TrainRecordingFilterDTO, TrainRecordingFilterOptionsDTO, TrainRecordingService } from '../generated';

export const trainrecordingFilterKeys = {
  base: () => ['trainRecordingFilter'] as const,
  one: ({ jobsiteId, filter }: TrainRecordingFilterOptionsProps) =>
    [...trainrecordingFilterKeys.base(), jobsiteId, filter] as const,
};

export interface TrainRecordingFilterOptionsProps {
  jobsiteId: string | undefined;
  filter: TrainRecordingFilterDTO | undefined;
}

export function trainRecordingFilterOptions({ jobsiteId, filter }: TrainRecordingFilterOptionsProps) {
  return queryOptions({
    queryKey: trainrecordingFilterKeys.one({ jobsiteId, filter }),
    queryFn: async (): Promise<TrainRecordingFilterOptionsDTO> => {
      if (!jobsiteId) throw new Error('jobsiteId is required');

      const response = await TrainRecordingService.trainRecordingControllerGetFilterOptions({
        path: { jobsiteId: jobsiteId },
        query: { filter: [filter || {}] },
      });

      if (response.data !== undefined) {
        return response.data;
      } else {
        throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
      }
    },
    enabled: !!jobsiteId,
  });
}

export function useTrainRecordingFilterOptions(props: TrainRecordingFilterOptionsProps) {
  return useQuery(trainRecordingFilterOptions(props));
}
